module.exports = {
  // 功能权限指令
  has: {
    inserted(el, binding, vnode) {
      let btnValue = binding.value;
      let boolean = false;

      let authFromLocal = vnode.context.$store.state.permission.authFromLocal;
      // 本地开发-放开所有权限
      if (authFromLocal) {
        boolean = true;
      } else {
        boolean = vnode.context.$store.state.permission.buttons.includes(btnValue);
      }

      !boolean && el.parentNode.removeChild(el);
    }
  },
  // 阻止按钮重复点击
  preventReClick: {
    inserted(el, binding) {
      el.addEventListener('click', () => {
        if (!el.disabled) {
          el.disabled = true;
          el.style.cursor = 'not-allowed';
          setTimeout(() => {
            el.disabled = false;
            el.style.cursor = 'pointer';
          }, binding.value || 1000);
        }
      });
    }
  },
  ellipsis: {
    inserted(el, binding, vnode) {
      let elWidth = el.offsetWidth;
      let fontSize = window.getComputedStyle(el, null).getPropertyValue('font-size');
      let textWidth = el.innerText.length * parseFloat(fontSize);

      if (textWidth > elWidth) {
        el.classList.add('ellipsis');
        el.setAttribute('title', el.innerText);
      }
    }
  }
};
